export enum EUsersFilter {
  MY_TEAMS = 'MY_TEAMS',
  INVITATIONS = 'INVITATIONS',
}